import controller from './kform-form.controller';
import template from './kform-form.html';

const kformFormDirective = /* @ngInject */ () => ({
	restrict: 'E',
	replace:  true,
	scope:    {
		disableComponents: '=?',
		files:             '=?',
		form:              '=',
		formId:            '@?id',
		hideComponents:    '=?',
		name:              '=?',
		options:           '<',
		readOnly:          '=?',
		requireComponents: '=?',
		submission:        '=',
	},
	controller,
	template,
});

export default kformFormDirective;
